<template>
    <div class="productecall">
        <!--banner-->
        <div class="banner outer">
            <div class="inside1490">
                <h1 class="banner_title">易外呼APP
                <!-- <span class="banner_rpo">HR版</span> -->
                </h1>
                <p class="banner_txt">易猎云旗下免费外呼app产品，可在易猎云系统中对候选人进行一键外呼，<br/>一键短信发送。支持自动通话录音及通话统计等功能
                </p>
            </div>
        </div>
        <!--图片文字排版1-->
        <div class="outer">
                <div class="inside1490 textimgbox">
                <img
                    class="fl"
                    style="width: 768px;height: 442px;margin-top: 122px;"
                    src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/ecall/new_pic_02%402x.png"
                />
                <div class="fr">
                    <h2>免拨号在线外呼</h2>
                    <p class="text_detail">免除手动拨号，支持系统外呼<br/> 外呼显示本机号码，免于拒接<br/> 系统发送本机短信，触达率高</p>
                </div>
                </div>
            </div>
      <!--清除浮动-->
      <div class="clear"></div>
        <!--文字图片排版2-->
        <div class="outer">
        <div class="inside1490 imgtextbox">
          <div class="fl">
            <h2 style="text-align: left">录音自动存档</h2>
            <p class="text_detail">通话录音自动关联候选人<br/> 可对外呼录音进行复盘、话术打磨<br/> 通话录音质检</p>
          </div>
          <img
            class="fr"
            style="width: 768px;height: 502px;margin-top: 80px;"
            src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/ecall/pic_02%402x.png"
          />
        </div>
      </div>
      <!--清除浮动-->
      <div class="clear"></div>
        <!--图片文字排版1-->
        <div class="outer">
        <div class="inside1490 textimgbox">
            <img
                class="fl"
                style="width: 368px;height: 442px;margin-top: 122px;margin-left: 200px;"
                src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/ecall/pic_03%402x.png"
            />
            <div class="fr">
                <h2>外呼数据分析</h2>
                <p class="text_detail">统计呼叫数量、时长、接通率等关键数据<br/> 支持有效通时、有效通量考核<br/> 外呼接通率过低预警</p>
            </div>
        </div>
            </div>
      <!--清除浮动-->
      <div class="clear"></div>
      <div class="security outer">
          <div class="inside1490 security_child">
            <div class="security_left"><img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_customer_service%402x.png"/></div>
            <div class="security_right">
              <p class="p1">即刻开启数字化招聘人效提升之旅</p>
              <!-- <div class="security_center" @click="trial()">申请试用</div> -->
            </div>
           
          </div>
      </div>
       <!--申请试用组件-->
    <populone v-if="windowflags" :isshow="windowflags" :selectId="''" :he="true" @handleChange="changewindows" />
    </div>
</template>
<script>
  import populone from "@/components/views/popul/populone";
  export default {
    name: "productecall",
    data() {
        return{
            windowflags: false,
        }
    },
    components: {
        populone,
    },
    methods:{
      trial(){
        this.windowflags = true;
        },
        changewindows(value) {
         this.windowflags = value;
        },
    },
    metaInfo: {
        title: '易外呼-易猎云旗下产品免费系统外呼产品',
        meta: [
          {
            name: 'keywords',
            content: '易外呼，外呼软件，免费呼叫中心系统，通话录音软件'
          },
          {
            name: 'description',
            content: '易猎云旗下免费外呼app产品，可在易猎云招聘管理系统中对候选人进行一键外呼，一键短信发送，支持自动通话录音及通话统计等功能'
          }
        ]
    },
}
</script>
<style lang="less" scoped>
@import "~@/assets/css/style/index.less";
.productecall{
    margin-top: 85px;
  .banner {
    width: 100%;
    height: 730px;
    background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/ecall/banner_outgoing%20call%402x.png');
    background-repeat: no-repeat;
    background-size: 100%;
    padding-top: 230px;
    box-sizing: border-box;
    .banner_title{
      font-size: 60px;
      color: #1D2754;
      line-height: 112px;
    }
    .banner_rpo{
        display: inline-block;
        width: 80px;
        height: 34px;
        border-radius: 7px;
        border: 1px solid #5666FF;
        font-size: 20px;
        color: #5666FF;
        line-height: 34px;
        text-align: center;
        vertical-align: top;
        margin-top: 30px;
      }
    .banner_txt{
      font-size: 24px;
      color: #3A4D70;
      line-height: 40px;
    }
  }
  .textimgbox {
      width: 1490px;
      height: 610px;
      border-bottom: solid 1px #E4E6EE;
      h2 {
        font-size: 42px;
        margin-top: 126px;
        font-weight: 500;
        color: #1d2754;
        line-height: 48px;
      }
      .text_detail{
        width: 453px;
        font-size: 24px;
        color: #7087A6;
        line-height: 42px;
        margin-top: 31px;
      }
    }
    .imgtextbox {
      width: 1490px;
      height: 610px;
      border-bottom: solid 1px #E4E6EE;
      h2 {
        font-size: 42px;
        margin-top: 120px;
        font-weight: 500;
        color: #1d2754;
        line-height: 48px;
      }
      .text_detail{
        width: 408px;
        font-size: 24px;
        color: #7087A6;
        line-height: 42px;
        margin-top: 31px;
      }
    }
    .clear {
      clear: both;
    }
    .security{
      width: 100%;
      height: 277px;
      background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/bg_01%402x.png');
      background-repeat: no-repeat;
      background-size: 100% 102%;
      padding-top: 53px;
      box-sizing: border-box;
      .security_child{
        display: flex;
        .security_left{
            margin-left: 197px;
              img{
                width: 145px;
                height: 128px;
              }
        }
        .security_right{
             margin-left: 37px;
              .p1{
              display: inline-block;
              font-size: 48px;
              font-weight: 500;
              color: #ffffff;
              text-align: left;
              margin-top: 47px;
          }
        }
        .security_center{
          width: 158px;
          height: 66px;
          background: #FFFFFF;
          border-radius: 7px;
          line-height: 66px;
          text-align: center;
          font-size: 24px;
          color: #215FFF;
          cursor: pointer;
          margin: 0 auto;
          margin-top: 40px;
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/product/productecall.vue